import axios from 'axios';

export const curriculumService = {
	getCurriculum,
	getCurriculums,
	getUserCurriculum,
	getTranslatorProducts,
	updateCurriculum,
	getCurriculumDocx,
	uploadDocument,
	uploadPortrait,
	downloadPortrait
};

function getCurriculum(idCurriculum) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/cv/"+idCurriculum, {params: {}});
}
function getCurriculums() {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/cv/", {params: {}});
}
function getUserCurriculum(idUser) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/cv/user/"+idUser, {params: {}});
}
function getTranslatorProducts() {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/cv/products/", {params: {}});
}

function updateCurriculum(cv) {
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/cv/"+cv.id+"/", JSON.stringify(cv), headers);
}
function getCurriculumDocx(idCurriculum) {
	const headers = {
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		responseType: 'arraybuffer',
		params: {
		}
	}
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/cv/docx/"+idCurriculum, headers);
}

function uploadDocument(cvId, doc){
//	console.log("docHref: "+docHref);
	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	const formData = new FormData();
	formData.append('document', new File([doc], doc.name, { type: doc.type }));
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/cv/"+cvId+"/document", formData, headers);
}

function uploadPortrait(cvId, doc){
//	console.log("docHref: "+docHref);
	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	const formData = new FormData();
	formData.append('document', new File([doc], doc.name, { type: doc.type }));
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/cv/"+cvId+"/portrait", formData, headers);
}

function downloadPortrait(docId){
	//console.log("SERVICE: download protrait: "+docId);
	const headers = {
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		responseType: 'blob',
		params: {
		}
	}
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/document/"+docId+"/content", headers);
}

